import { assetPicker } from '@naker/design/Pickers/assetPicker';
import { InputGroup } from '@naker/design/Layers/actionPanel';
import { actionPanel } from '@naker/design/Layers/panels';
import { ExportModal } from '@naker/design/User/exportModal';
import { Header } from '@naker/design/User/header';

import { Environment, environmentInterface } from '../viewer/environment';
import { Particle, particleInterface } from '../viewer/particle';
import { colorSettingsClass } from './colorSettings';
import { geometrySettingsClass } from './geometrySettings';
import { AnimationSettings } from './animationSettings';
import { backInterface } from '../viewer/back';
import { particleList } from './service/particleList';
import { spy, api } from './service/session';

import { el, mount, unmount } from 'redom';

import { Undo } from '@naker/design/Services/undo';
import { Session } from '@naker/design/Services/session';

/*
  +------------------------------------------------------------------------+
  | PRESET MANAGER                                                         |
  +------------------------------------------------------------------------+
*/

export let presets: Array < backInterface > = [
    {
        name: 'Cherry_Blossom',
        "particle": { "direction1": { "x": 100, "y": 0, "z": 0 }, "direction2": { "x": 0, "y": 0, "z": 0 }, "life": 2.8, "power": 0.218, "texture": "https://res.cloudinary.com/naker-io/image/upload/v1566560053/flame_04.png", "number": 298, "colorStart": [57, 40, 181, 0.13], "colorEnd": [204, 182, 155, 0.07], "sizeStart": 0.8, "sizeEnd": 1.6 }, "environment": { "sensitivity": 0.51, "gradient": "horizontal", "colorStart": [223, 160, 192, 1], "colorEnd": [230, 64, 172, 1] } 
    },
    {
        name: "Sleepy_Night",
        "particle": { "direction1": { "x": 0, "y": 0, "z": 0 }, "direction2": { "x": 0, "y": 0, "z": 0 }, "life": 10000000, "power": 0, "texture": "https://res.cloudinary.com/naker-io/image/upload/v1566560053/circle_05.png", "number": 417, "colorStart": [223, 253, 35, 0.65], "colorEnd": [142, 141, 179, 0.82], "sizeStart": 0.54, "sizeEnd": 1.08 }, "environment": { "gradient": "horizontal", "sensitivity": 0.8, "colorStart": [28, 1, 90, 1], "colorEnd": [90, 25, 101, 1] }
    },
    { 
        name: "Algae_Journey",
        "particle": { "direction1": { "x": 0, "y": 100, "z": 100 }, "direction2": { "x": 0, "y": 0, "z": 0 }, "life": 7.6, "power": 0.02, "texture": "https://res.cloudinary.com/naker-io/image/upload/v1566560053/trace_06.png", "number": 1317, "colorStart": [255, 255, 255, 0.47], "colorEnd": [255, 255, 255, 0.07], "sizeStart": 0.5, "sizeEnd": 1 }, "environment": { "sensitivity": 0.4, "gradient": "horizontal", "colorStart": [6, 185, 189, 1], "colorEnd": [64, 225, 43, 1] } 
    },
    { 
        name: "Blue_Gradient",
        "particle": { "direction1": { "x": 0, "y": 0, "z": 0 }, "direction2": { "x": 0, "y": -100, "z": -100 }, "life": 0.2, "power": 0.02, "texture": "https://res.cloudinary.com/naker-io/image/upload/v1566560053/muzzle_05.png", "number": 0, "colorStart": [106, 254, 187, 0.81], "colorEnd": [240, 156, 150, 0.64], "sizeStart": 0.7, "sizeEnd": 1.4 }, "environment": { "sensitivity": 0.5, "gradient": "radial", "colorStart": [58, 185, 221, 1], "colorEnd": [55, 0, 82, 1] } 
    },
    {
        name: "Cosy_Dreamin",
        "particle": { "direction1": { "x": 0, "y": 100, "z": 100 }, "direction2": { "x": 0, "y": 0, "z": 0 }, "life": 5, "power": 0.01, "texture": "https://res.cloudinary.com/naker-io/image/upload/v1566560053/circle_05.png", "number": 20, "colorStart": [116, 129, 92, 0.13], "colorEnd": [198, 188, 107, 0.52], "sizeStart": 1.57, "sizeEnd": 3.14 }, "environment": { "sensitivity": 0.8, "gradient": "horizontal", "colorStart": [50, 22, 103, 1], "colorEnd": [20, 86, 205, 1] } 
    },
    { 
        name: "Sweet_Trip",
        "particle": { "direction1": { "x": 100, "y": 0, "z": 0 }, "direction2": { "x": -100, "y": 0, "z": 0 }, "life": 4.2, "power": 0.01, "texture": "https://res.cloudinary.com/naker-io/image/upload/v1566560053/circle_04.png", "number": 1803, "colorStart": [215, 188, 72, 0.38], "colorEnd": [114, 42, 77, 0.37], "sizeStart": 0.7, "sizeEnd": 1.4 }, "environment": { "sensitivity": 0.2, "gradient": "radial", "colorStart": [213, 67, 132, 1], "colorEnd": [84, 52, 213, 1] } 
    },
    { 
        name: "Blue_Hour",
        "particle": { "direction1": { "x": 0, "y": 100, "z": 0 }, "direction2": { "x": 0, "y": -100, "z": -100 }, "life": 1.2, "power": 0.01, "texture": "https://res.cloudinary.com/naker-io/image/upload/v1566560053/flare_01.png", "number": 1004, "colorStart": [211, 66, 140, 0.33], "colorEnd": [208, 117, 107, 0.2], "sizeStart": 0.42, "sizeEnd": 0.84 }, "environment": { "sensitivity": 0.6, "gradient": "radial", "colorStart": [15, 93, 148, 1], "colorEnd": [59, 25, 97, 1] } 
    },
    { 
        name: "Mystic_Bubbles",
        "particle": { "direction1": { "x": 0, "y": 0, "z": 0 }, "direction2": { "x": 0, "y": 0, "z": 0 }, "life": 7.9, "power": 0.065, "texture": "https://res.cloudinary.com/naker-io/image/upload/v1566560053/light_02.png", "number": 10, "colorStart": [37, 37, 37, 0.67], "colorEnd": [3, 3, 3, 0.74], "sizeStart": 1.95, "sizeEnd": 3.9 }, "environment": { "sensitivity": 0.5, "gradient": "radial", "colorStart": [18, 18, 18, 1], "colorEnd": [0, 0, 0, 1] } 
    },
    { 
        name: "Clear_Metal",
        "particle": { "direction1": { "x": 100, "y": 0, "z": 0 }, "direction2": { "x": 0, "y": 0, "z": -100 }, "life": 0.7, "power": 0.029, "texture": "https://res.cloudinary.com/naker-io/image/upload/v1566560053/spark_07.png", "number": 1745, "colorStart": [237, 118, 221, 0.32], "colorEnd": [119, 182, 203, 0.55], "sizeStart": 0.2, "sizeEnd": 0.4 }, "environment": { "sensitivity": 0.2, "gradient": "horizontal", "colorStart": [52, 115, 131, 1], "colorEnd": [180, 225, 243, 1] } 
    },
    { 
        name: "White_Metal",
        "particle": { "direction1": { "x": 0, "y": 0, "z": 100 }, "direction2": { "x": 0, "y": 0, "z": -100 }, "life": 2.3, "power": 0.029, "texture": "https://res.cloudinary.com/naker-io/image/upload/v1566560053/scratch_01.png", "number": 140, "colorStart": [255, 255, 255, 0.98], "colorEnd": [69, 130, 196, 0.82], "sizeStart": 0.53, "sizeEnd": 1.06 }, "environment": { "sensitivity": 0.4, "gradient": "radial", "colorStart": [255, 255, 255, 1], "colorEnd": [0, 0, 0, 1] } 
    },
];

export class presetSettingsClass extends Header{

    mainControl: InputGroup;

    environment: Environment;
    particle: Particle;

    undo: Undo;
    session: Session;
    geometrySettings: geometrySettingsClass;
    animationSettings: AnimationSettings;
    colorSettings: colorSettingsClass;
    control: HTMLElement;
    loader: HTMLElement;
    projectname: HTMLInputElement;
    projectsave: HTMLButtonElement;

    constructor(session: Session, undo: Undo, exportModal: ExportModal, environment: Environment, particle: Particle) {
        super(session, undo, exportModal);
        
        let exportbutton = el('div.nav-button.presets-button-main.project-save', { onclick: () => { this.exportProject(); } }, 'Export Project');
        mount(this.control, exportbutton);

        this.environment = environment;
        this.particle = particle;

        this.addInput();
    }
    
    setEditors(geometrySettings: geometrySettingsClass, animationSettings: AnimationSettings, colorSettings: colorSettingsClass) {
        this.geometrySettings = geometrySettings;
        this.colorSettings = colorSettings;
        this.animationSettings = animationSettings;
    }

    exportProject() {
        if (!api.isConnected() && this.session.saving) this.loginModal.show();
        else {
            spy.track('Backdesign Export');
            this.exportModal.setEmbedCode();
            this.exportModal.show();
            assetPicker.hidePicker();
        }
    }

    addInput() {
        this.templateList = el('div.presets-list.asset-picker', { onclick: () => { this.hideTemplatePicker(); } }, presets.map(p =>
            el('img.asset-button', {
                onclick: () => {
                    spy.track('Template Click');
                    this.setBackground(p);
                },
                src: 'https://d2uret4ukwmuoe.cloudfront.net/backtemplates/'+ p.name +'.jpg'
            },
            p.name)
        ));
            
        this.mainControl = new InputGroup('preset', actionPanel, this.undo);

        let randomButton = el('div.input-button.input-button-center.button-primary.random-button', { onclick: () => { this.radomizeAllParameters(); } }, 'Randomize' );
        mount(this.mainControl.el, randomButton);

        let presetButton = el('div.input-button.input-button-center.button-primary.template-button', {
            onclick: () => { 
                assetPicker.hidePicker();
                if (!this.templateShown) this.showTemplatePicker();
                else this.hideTemplatePicker();
            }
        }, 'Template');
        
        mount(this.mainControl.el, presetButton);
    }

    templateShown = false;
    templateList = HTMLElement;
    showTemplatePicker () {
        this.templateShown = true;
        let container = document.getElementById("container");
        mount(container, this.templateList);
    }

    hideTemplatePicker() {
        this.templateShown = false;
        let container = document.getElementById("container");
        unmount(container, this.templateList);
    }

    setBackground(backOptions: backInterface) {
        this.particle.resetSystem();
        this.particle.setOptions(backOptions.particle);
        this.particle.checkParticlePower(backOptions.particle.power);
        this.environment.setOptions(backOptions.environment);
        this.colorSettings.resetInput(backOptions.environment, backOptions.particle);
        this.geometrySettings.resetInput(backOptions.particle);
        this.animationSettings.resetInput(backOptions.particle, backOptions.environment);
        this.saveAnimation();
        this.undo.pushState();
    }

    gradientList: Array<environmentInterface["gradient"]> = ['vertical', 'horizontal', 'radial'];
    radomizeAllParameters() {
        spy.track('Randomize Click');
        assetPicker.hidePicker();
        let particle: particleInterface = {};
        particle.colorStart = this.getRandomColor(true);
        particle.colorEnd = this.getRandomColor(true);
        particle.direction1 = this.getRandomVector(1);
        particle.direction2 = this.getRandomVector(-1);
        particle.life = this.getRandomNumber(0, 10, 10);
        particle.power = this.getRandomNumber(0, 0.5, 10);
        particle.number = this.getRandomNumber(0, 2000, 1);
        let size = this.getRandomNumber(0, 1, 10);
        particle.sizeStart = size;
        particle.sizeEnd = size * 2;
        particle.texture = this.getRandomTexture();

        let environment: environmentInterface = {};
        environment.colorEnd = this.getRandomEnvColor();
        environment.colorStart = this.getRandomEnvColor();
        environment.sensitivity = this.getRandomNumber(0, 1, 10);
        let gradient = this.getRandomNumber(0, 2, 1);
        environment.gradient = this.gradientList[gradient];
        let randomBackground: backInterface = { particle: particle, environment: environment };
        this.setBackground(randomBackground);
    }

    getRandomNumber(min: number, max: number, accuracy: number) {
        return Math.round(min + Math.random() * (max - min) * accuracy) / accuracy;
    }

    getRandomEnvColor() {
        return [
            this.getRandomNumber(0, 255, 1), 
            this.getRandomNumber(0, 255, 1), 
            this.getRandomNumber(0, 255, 1), 
            1
        ];
    }

    getRandomColor(alpha?: boolean) {
        return [
            this.getRandomNumber(0, 255, 1), 
            this.getRandomNumber(0, 255, 1), 
            this.getRandomNumber(0, 255, 1), 
            (alpha)? this.getRandomNumber(0.5, 1, 100) : 1
        ];
    }

    getRandomVector(sign: number) {
        let vec = { x: 0, y: 0, z: 0 };
        for (let key in vec) {
            if (Math.random() > 0.7) vec[key] = sign * 100;
        }
        return vec;
    }

    getRandomTexture() {
        let l = particleList.length - 1;
        let rand = Math.ceil(Math.random() * l);
        return particleList[rand].url;
    }
}